<script lang="ts">
	import { dldl, yyyy, zzzz } from "../store.svelte";
	import { onMount, onDestroy, tick } from "svelte";
	import { fly } from "svelte/transition";

	import Fa, { FaLayers, FaLayersText } from "svelte-fa";
	import {
		faSlash,
		faArrowLeft,
		faArrowRight,
		faPlus,
		faLocationDot,
		faMinus,
		faEllipsisVertical,
		faLayerGroup,
		faMagnifyingGlass,
		faTimes,
	} from "@fortawesome/free-solid-svg-icons";
	import { quintIn } from "svelte/easing";

	let {showLayerToggle = $bindable()} = $props()
	let layerList;

	let handleLayer = (layer:string) => {
			zzzz.emit("handleLayer", layer)
	};
	onMount(() => {
		dldl('LayerToggle.svelte', 'LayerToggle mounted')
	})
</script>

<div id="layer-toggler" class="layer-card" transition:fly={{ x: 50, duration: 300 }}>
	<div class="layer-header">
		<span class="layer-title">
			<Fa icon={faLayerGroup} /> Map Layers
		</span>
		<button
			class="close-button"
			onclick={() => {
				showLayerToggle = false;
			}}
			aria-label="close"
		>
			<Fa icon={faTimes} size="1x" />
		</button>
	</div>
	<div id="layer-list" class="layer-content">
		<div class="layer-buttons">
			{#each yyyy.map.tableNames as lyr}
				<button
					class="layer-button"
					class:inactive={!lyr.vis}
					onclick={() => {handleLayer(lyr.tablename)}}
				>
					{lyr.tablename}
				</button>
			{/each}
			
			<button 
				class="layer-button satellite-button" 
				onclick={() => zzzz.emit("handleSatellite")}
			>
				{yyyy.map.isSatellite ? 'Basemap' : 'Satellite'}
			</button>
		</div>
	</div>
</div>

<style>
	.layer-card {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 15px;
		z-index: 9;
		max-width: 350px;
		max-height: 75vh;
		overflow: hidden;
		border: 1px solid #dbdbdb;
		border-radius: 8.775px;
		background-color: #fff;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
		display: flex;
		flex-direction: column;
	}

	.layer-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.25rem;
		border-bottom: 1px solid #eee;
		background-color: #fff;
		position: sticky;
		top: 0;
		z-index: 1;
	}

	.layer-title {
		font-weight: bold;
		color: #363636;
		font-size: 14px;
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 0.3rem;
	}

	.close-button {
		background: transparent;
		border: none;
		color: #ff3e00;
		cursor: pointer;
		padding: 0;
		font-size: 16px;
	}

	.close-button:hover {
		color: #cc3200;
	}

	.layer-content {
		flex: 1;
		overflow-y: auto;
		padding: 1rem;
		font-size: 0.9rem;
		max-height: calc(75vh - 2rem);
	}

	.layer-buttons {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.layer-button {
		padding: 0.5rem 1rem;
		border: 1px solid #3273dc;
		background-color: #3273dc;
		color: white;
		border-radius: 4px;
		font-size: 0.9rem;
		cursor: pointer;
		transition: all 0.2s;
		text-align: center;
	}

	.layer-button:hover {
		background-color: #2366d1;
		border-color: #2366d1;
	}

	.layer-button.inactive {
		background-color: white;
		color: #3273dc;
	}

	.layer-button.inactive:hover {
		background-color: #f5f5f5;
	}

	.satellite-button {
		margin-top: 0.5rem;
	}

	/* Mobile Compact Styles */
	@media only screen and (max-width: 768px) {
		.layer-card {
			max-width: 280px;
			max-height: 60vh;
			right: 10px;
		}

		.layer-header {
			padding: 0.15rem;
		}

		.close-button {
			padding: 0.25rem;
		}

		.layer-content {
			padding: 0.75rem;
			font-size: 0.85rem;
		}

		.layer-buttons {
			gap: 0.4rem;
		}

		.layer-button {
			padding: 0.4rem 0.75rem;
			font-size: 0.85rem;
		}

		.satellite-button {
			margin-top: 0.4rem;
		}
	}
</style>
